import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Icon from '../../../../../../../../libraries/utils/components/icon';
import noop from '../../../../../../../../libraries/utils/noop';

class ShowButton extends Component {
  render() {
    var { iconName, onClick } = this.props;
    return (
      <button className="show-button" onClick={onClick}>
        <Icon name={iconName} className={iconName} />
        <span className="label">Show</span>
      </button>
    );
  }
}
ShowButton.defaultProps = {
  onClick: noop
};

ShowButton.propTypes = {
  iconName: PropTypes.string,
  onClick: PropTypes.func
};

ShowButton.displayName = 'ShowButton';

export default ShowButton;
